import { render, staticRenderFns } from "./JobsQuoteApproval.vue?vue&type=template&id=518893ae"
import script from "./JobsQuoteApproval.vue?vue&type=script&lang=js"
export * from "./JobsQuoteApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports